/**
 * Logo component for the navigation bar
 */
export default function Logo() {
  return (
    <div className="logo">
      <span role="img">🍿</span>
      <h1>MovieMood</h1>
    </div>
  );
}

